<template>
  <div>
    <Header title="我的免修申请"></Header>
    <div class="my-apply1">
      <p class="apply-ttl" :style="this.applyDetail.shzt == '通过' ? 'color: #12DDD6;' : 'color:#F86969;'">{{this.applyDetail.shzt}}</p>
      <p class="apply-sub">{{this.applyDetail.coursename}}</p>
      <div class="info-text">
        <p v-if="this.schoolCode!='12561'">审核人：{{this.applyDetail.shr}}</p>
        <p>申请时间：{{this.applyDetail.sqsj}}</p>
        <div class="reason">
          <p>免修原因：</p>
          <p class="reason-txt">{{this.applyDetail.sqyy}}</p>
        </div>
        <p>学时：{{this.applyDetail.period}}</p>
        <p>学分：{{this.applyDetail.credit}}</p>
        <p>课号：{{this.applyDetail.kch}}</p>
        <p>学年学期：{{this.applyDetail.xnxq01id}}</p>
        <p>课程性质：{{this.applyDetail.kclb}}</p>
        <p>考试方式：{{this.applyDetail.ksfs}}</p>
        <p>成绩标识：{{this.applyDetail.cjbs}}</p>
        <p>免修类型：{{this.applyDetail.mxlx}}</p>
      </div>
    </div>
    <div class="delay-btn" v-if="this.schoolCode=='12561'&&this.applyDetail.shzt!='审核中'&&this.applyDetail.shzt!='通过'&&this.applyDetail.sjkz=='1'">
      <button  @click="goApply()">重新申请</button>
    </div>

  </div>
</template>

<script>
  export default{
    data(){
      return{
        applyDetail:[],
          mxfs:[],
          schoolCode: sessionStorage.getItem("schoolCode")
      }
    },
    created(){
      this.applyDetail = JSON.parse(this.$route.query.data);
      this.mxfs = JSON.parse(this.$route.query.mxfs);
       // console.log(this.mxfs)
       this.schoolCode = sessionStorage.getItem("schoolCode");
    },
     methods:{
       goApply(){
           this.$router.push({
               path:'/student/exemptApply',
               query:{
                   'data':JSON.stringify(this.applyDetail),
                   'mxfs':JSON.stringify(this.mxfs)
               }
           })
       }
     }
  }
</script>

<style lang="less" scoped>
  .my-apply1{padding: 20px;}
  .apply-ttl{font-size: 24px;font-weight: 700;}
  .apply-sub{font-size: 18px;color: @attendance-color-1;font-weight: 700;margin: 20px 0;}
  .my-apply1 .reason{display: flex;}
  .reason-txt{flex: 1;}
  .my-apply1 .info-text{font-size: 14px;color: @attendance-color-2;line-height: 25px;}
  .delay-btn{position: fixed;padding: 20px;width: 100%;text-align: center;bottom: 0;background-color: @attendance-color-3;box-sizing: border-box;}
  .delay-btn button{background-color: @attendance-background-color-7;color: @attendance-background-color-1;padding: 11px 0;width: 100%;border-radius: 3px;}
</style>



// WEBPACK FOOTER //
// src/components/student/exemptTest/myExemptApply1.vue